import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Button from "./Button";
import { AppContext } from "../utils/context";

class CheckoutProcessing extends Component {

  render() {
    const { title, paysafe_after_payclick, paysafe_status, initPaysafe, shift4Loading, paysafeLoading } = this.props;
    const { localLanguage, settings, config } = this.context;
    return (
      <form key={4} className="w-full checkoutProcessing">
        <Helmet>
          {settings.scripts_payment_info && <script>{settings.scripts_payment_info}</script>}
        </Helmet>
        {config.webPayments !== "shift4" && <h2 className="mb-6">{title}</h2>}
        <div className="flex flex-wrap items-center h-64">
          <div className="m-auto" id="paymentInfoWrapper">

            {config.webPayments === 'paysafe' && paysafeLoading && ( // Paysafe checkout loader
              <div className="flex text-2xl text-primary">
                <div className="bump-loader" style={{ position: 'relative', marginRight: '20px', marginTop: '-15px', left: '0%' }}>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                {paysafe_after_payclick ? localLanguage.general_processing_payment : localLanguage.general_payment_redirect}
              </div>
            )}

            {config.webPayments === 'stripe' && ( // Stripe checkout loader
                <div className="flex text-2xl text-primary">
                    <div className="bump-loader" style={{ position: 'relative', marginRight: '20px', marginTop: '-15px', left: '0%' }}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    {window.location.href.includes('process-order') ? localLanguage.general_processing_payment : localLanguage.general_payment_redirect}
                </div>
            )}

            {config.webPayments === 'shift4' && ( // Shift4 checkout
                <>
                    <div id="i4goFrame"></div>

                    {shift4Loading ? <div className="flex text-2xl text-primary">
                        <div className="bump-loader" style={{ position: 'relative' }}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div> :
                      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button
                          className="pay-button pay-hidden google-play-button"
                          style={{backgroundColor: '#4285F4', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', marginRight: '10px'}}
                          type="button"
                        //   class=" text-white bg-[#050708] hover:bg-[#050708]/80 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mb-2"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="20" viewBox="0 0 48 48">
                            <path fill="#fbc02d" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#e53935" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4caf50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1565c0" d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
                          </svg>
                          Pay
                        </button>

                        <button
                          className="pay-button pay-hidden apple-play-button"
                          style={{backgroundColor: 'black', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', marginRight: '10px'}}
                          type="button"
                        //   class=" text-white bg-[#050708] hover:bg-[#050708]/80 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mb-2"
                        >
                          <svg class="w-5 h-5 me-2 -ms-1" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="apple" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path></svg>
                          Pay
                        </button>
                      </div>
                    }
                </>
            )}

            {config.webPayments === 'paysafe' && !paysafe_status && !paysafeLoading && ( // Paysafe iframe closed by user
                <div>
                    <div className="flex text-2xl text-primary">{localLanguage.general_payment_cancelled}</div>
                    <div className="w-full flex flex-wrap mt-12 justify-between">
                        <Link
                            to={"/"}
                            className="no-underline py-3 px-6 bg-danger hover:bg-danger-dark text-primary-contrast"
                        >
                            {localLanguage.general_cancel_order}
                        </Link>
                        <Button onClick={() => initPaysafe()} color="primary" content={localLanguage.general_make_payment} />
                    </div>
                </div>)
            }

          </div>
        </div>
      </form>
    );
  }
}
CheckoutProcessing.contextType = AppContext;

export default CheckoutProcessing;
